import isEmpty from 'lodash/isEmpty';
import API_URL from "../constant/api.config";
import { trim } from "lodash";
import axiosInstance from '../axiosHttp';
import { setAuthHeaders } from "../utils/common";
import axios from 'axios';

export const getSubscriptionPlanList = (offset, limit, columnName = "created_at", sortDirection = "DESC", type, searchTxt = null) => async (dispatch) => {
    searchTxt = trim(searchTxt);
    searchTxt = btoa(searchTxt);
    const searchQueryString = isEmpty(searchTxt) ? '' : ('/' + searchTxt);
    const headers = setAuthHeaders();
    return await axiosInstance.get(API_URL + '/subscription-plan/' + offset + '/' + limit + '/' + columnName + '/' + sortDirection + '/' + type + searchQueryString,
        {
            headers
        }
    ).then((response) => {
        return response.data;
    }).catch((err) => {
        console.log("Error ==== ", err);
    })
}

export const createPlan = (data) => async (dispatch) => {
    const headers = setAuthHeaders();
    return await axiosInstance.post(API_URL + '/subscription-plan', data, { headers }).then((response) => {
        // console.log(" API response in subscriptionplan action File ", response);
        return response.data;
    }).catch((err) => {
        console.log("Error ========== ", err);
    })
}

export const deletePlan = (id) => (dispatch) => {
    const headers = setAuthHeaders();
    return axiosInstance.delete(API_URL + '/subscription-plan/' + id, { headers }).then((response) => {
        return response.data;
    }).catch((err) => {
        console.log("Error ========== ", err);
    });
}

export const getPlan = (id) => (dispatch) => {
    const headers = setAuthHeaders();
    return axiosInstance.get(API_URL + '/subscription-plan/' + id, { headers }).then((response) => {
        return response.data;
    }).catch((err) => {
        console.log("Error ========== ", err);
    });
}

export const updatePlan = (id, data) => (dispatch) => {
    const headers = setAuthHeaders();
    return axiosInstance.post(API_URL + '/update-subscription-plan/' + id, data, { headers }).then((response) => {
        return response.data;
    }).catch((err) => {
        console.log("Error ========= ", err);
    })
}

export const checkPriority = (id, search_txt, type) => (dispatch) => {
    const headers = setAuthHeaders();
    return axiosInstance.post(API_URL + '/subscription/priority', { id, search_txt, type }, { headers }).then((response) => {
        return response.data;
    }).catch((err) => {
        console.log("Error ========= ", err);
    })
}

export const checkSubscriptionName = (id, search_txt, type) => (dispatch) => {
    const headers = setAuthHeaders();
    return axiosInstance.post(API_URL + '/subscription/plan-name', { id, search_txt, type }, { headers }).then((response) => {
        return response.data;
    }).catch((err) => {
        console.log("Error ========= ", err);
    })
}

export const supplierPlanList = () => (dispatch) => {
    const headers = setAuthHeaders();
    return axiosInstance.get(API_URL + '/supplier/plans', { headers }).then((response) => {
        return response.data;
    }).catch((err) => {
        console.log("Error ========= ", err);
    })
}

export const getPlanFetureSettings = () => async (dispatch) => {
  const headers = setAuthHeaders();

  try {
    const response = await axiosInstance.get(
      API_URL + "/plan-features",
      headers
    );

    console.log("GET Plan Features Response:", response.data);
    return response.data;
  } catch (err) {
    console.log(
      "Get Plan Features Error ========= ",
      err?.response?.data || err.message
    );
    throw err;
  }
};

export const addPlanFeatures = (rows) => async (dispatch) => {
  const formData = new FormData();

  rows.forEach((row, index) => {
    formData.append(`data[${index}][plan_id]`, row.plan_id);
    formData.append(`data[${index}][key_name]`, row.key_name);
    formData.append(`data[${index}][key_value]`, row.key_value);
  });

  try {
    const response = await axiosInstance.post(
      API_URL + "/plan-features",
      formData,
      {
        headers: {
          ...setAuthHeaders(),
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
};

